import { render, staticRenderFns } from "./contractTerminationList.vue?vue&type=template&id=6c20d534&scoped=true"
import script from "./contractTerminationList.vue?vue&type=script&lang=js"
export * from "./contractTerminationList.vue?vue&type=script&lang=js"
import style0 from "./contractTerminationList.vue?vue&type=style&index=0&id=6c20d534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c20d534",
  null
  
)

export default component.exports